import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';

export const useFileNavigation = ({ userContext }) => {
  const history = useHistory();
  const location = useLocation();
  const { handleBreadCrumbs, onFilterChange, fileManagerFilters } = useFileManagerContext();

  const setQuery = useCallback(
    (data) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('file_id', data?.object_id);

      history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    },
    [history, location.pathname]
  );

  const selectFile = useCallback(
    (e) => {
      if (e?.entry_type === 'folder') {
        handleBreadCrumbs(e);

        // Check if this is a shared folder and current user is a client
        const isSharedFolder = e?.folder_shared === true;
        const isClientUser = userContext?.access_level === 'client';
        const hasFolderId = e?.object_id && e?.object_id !== '' && e?.object_id !== 'undefined';
        const isCurrentlyInSharedMode = fileManagerFilters?.shared_folder === true;

        // Set shared_folder: true when:
        // 1. Client user clicking INTO any folder with valid folder_id when already in shared mode, OR
        // 2. Client user clicking INTO a shared folder for the first time
        const shouldSetSharedFolder = isClientUser && hasFolderId && (isCurrentlyInSharedMode || isSharedFolder);

        let data = {
          target: {
            name: 'selectedFolder',
          },
          value: e?.object_id,
          // Set shared_folder: true when client clicks any folder in shared mode or shared folder for first time
          // Otherwise preserve the current shared_folder state if it exists
          ...(shouldSetSharedFolder ? { shared_folder: true } : isCurrentlyInSharedMode ? { shared_folder: true } : {}),
          // Only set folder_shared and shared_contact_list for actually shared folders
          folder_shared: e?.entry_type === 'folder' && isSharedFolder && e?.file_shared_contact_id ? true : null,
          shared_contact_list: e?.entry_type === 'folder' && isSharedFolder && e?.file_shared_contact_id ? e?.file_shared_contact_id : null,
          folder_type: e?.folder_type,
          is_virtual: e?.is_virtual,
          is_system_folder: e?.is_system_folder,
        };
        onFilterChange(data);
      } else {
        setQuery(e);
      }
    },
    [fileManagerFilters, userContext]
  );

  return { setQuery, selectFile };
};
